import firebase from '../firebase'
import Store from '../store/Store'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import Vue from 'vue'
import StringHelpers from '../helpers/StringHelpers'
import TablesStore from '../store/CollectionsStore'

var db = firebase.database()

export default class {

static loadOffices(db) {
    let ref = DataHelpers.getRootRef().child('tables/global/offices/data')
    let officesArr = []
    this.streamCollection(ref, officesArr)

}

static streamCollection(ref, arr) {
    return new Promise( (resolve, reject) => {
        ref.on('value', snap => {
            this.snapshotFillArray(snap, arr)
            resolve(arr)
        })
    })
}

static tableToRef(office, table) {
    return DataHelpers.getRootRef().child('tables').child(office).child(table)
}

static streamToStore(office, table, preferences) {
    
    const tableRef = this.tableToRef(office, table)

    const p1 = new Promise( (resolve, reject) => {
        let dataRef = tableRef.child('data')

        dataRef.on('value', snap => {
        
            let data = []
            this.snapshotFillArray(snap, data)
            const count = data.length
            let payload = {
                office, table, data, count
            }
            
            Store.commit('setTable', payload)
            resolve(data)
        })
    })

    const p2 = new Promise( (resolve, reject) => {
        
        let fieldsRef = tableRef.child('fields')

        fieldsRef.on('value', snap => {
        
            let fields = []
            this.snapshotFillArray(snap, fields)
            let payload = {
                office, table, fields
            }
            
            Store.commit('setTable', payload)
            resolve(fields)
        })
    })

    const p3 = new Promise( (resolve, reject) => {
        
        let relationshipsRef = DataHelpers.getRootRef().child('tables').child(office).child('relationships')

        relationshipsRef.on('value', snap => {
        
            let relationships = []
            this.snapshotFillArray(snap, relationships)
            let payload = {
                office, table, relationships
            }
            
            Store.commit('setTable', payload)
            resolve(relationships)
        })
    })
}

static snapshotFillArray(snap, arr) {
    if(!arr)
        debugger

    let ordered = false

    //empty it first...
    for(let i = arr.length; i > 0; i--) {
        arr.pop()
    }
    
    snap.forEach(childSnapshot => {
        let item = childSnapshot.val()
        item._key = childSnapshot.key
        let pathArray = snap.ref.path.pieces_
        
        if(item.order)
            ordered = true

        item._path = pathArray.join('/')

        arr.push(item)
    })   

    if(ordered)
        arr = arr.sort(OrderHelpers.sortByOrder)
}   

static saveItem(item) {
    item._key = item._key || DataHelpers.getKey()
    let ref = DataHelpers.getRootRef().child(item._path).child(item._key)
    let newItem = this.removeMeta(item)
    console.log('Data4 > saveItem storing item to ' + ref.toString(), newItem)
    ref.update(newItem)
}

// //new version

// static saveRow(item) {
//     item._key = item._key || DataHelpers.getKey()
//     const key = item._key
//     const path = item._path
//     let newItem = this.removeMeta(item)
//     debugger
//     for(let prop in newItem) {
//         let ref = DataHelpers.getRootRef().child(path).child(key + '-' + prop).child('value')
//         ref.set(newItem[prop])
//     }
//     console.log('Data4 > saveRow storing item', item)
// }

static deleteItem(item) {
    let ref = DataHelpers.getRootRef().child(item._path).child(item._key)
    console.log('Data4 > deleteItem' + ref.toString())
    ref.remove()
}

static removeMeta(obj) {
    let newObj = Object.assign({}, obj)
    for(let prop in newObj) {
        if(prop.substr(0,1) == '_')
            delete newObj[prop]
    }
    return newObj
}

/* Older Stuff */

static fetchItemSingle (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let obj = this.objectFromSnapshot(snap)
            resolve(obj)
        })
    })       
}

static fetchValue (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let result = snap.val()
            resolve(result)
        })
    })       
}

static fetchItemByName (baseRef, name) {
    return new Promise((resolve, reject) => {
        baseRef.orderByChild('name').equalTo(name).once('value', (snap) => {
            let objects = this.arrayFromSnapshot(snap)
            if(objects && objects.length)
                resolve(objects[0])
            else
                resolve(null)
        })
    })       
}

static objectFromSnapshot(snap) {
    let item = snap.val()
    if(!item)
        return null
    item.meta = {}
    item.meta.key = snap.key
    let pathArray = [...snap.ref.path.pieces_]
    if(pathArray.length > 2 && pathArray[0] == 'tenants')
        item.meta.tenantKey = pathArray[1]
        
    pathArray.pop()
    item.meta.path = pathArray.join('/')  
    return item  
}

static fetchItemsFromFirebase (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            resolve(this.arrayFromSnapshot(snap))
        })
    })       
}   

static safelyGetKey(obj) {
    let key

    if(obj._key)
        return obj._key

    if(obj.meta && obj.meta.key)
        key = obj.meta.key

    let oldKey = (obj['.key'] || obj.key)
    
    if(oldKey) {
        if(!key) {
            console.log('safelyGetKey ONLY has old key', obj)
            key = oldKey
        }
        else
            console.log('safelyGetKey has redundant old key', obj)
    }
    
    return key
}

static safelyGetTenant(obj) {
    if(obj && obj.meta && obj.meta.tenantKey)
        return obj.meta.tenantKey
    else
        return Store.getters.tenantKey
}


static fetchItems(ref, storeName, localVariable) {
    if(Store.state[storeName].length) {
        console.log('fetchItems from cache', storeName)
        localVariable = Store.state[storeName]
        return
    }
    this.fetchItemsFromFirebase(ref).then(items => {
        console.log('fetchItems from db', storeName)

        let payload = {
            name: storeName,
            data: items,
        }
        Store.commit('saveItems', payload)
        localVariable = items
    })
}

static saveFieldToFirebase(ref, x) {
    //todo...  
}

static firebaseRefToPath(ref) {
    let refStr = ref.toString()
    let refArr = refStr.split(/\//).slice(3).join('/')
    return refArr
}

static firebaseRefToKey(ref) {
    let pathArray = [...ref.path.pieces_]
    pathArray.pop()
    return pathArray.join("/")
}  

static defaultValue(field) {
    if(field == '[tenantKey]')
        return DataHelpers.getTenantKey()
    if(field == '[stamp]')
        return DataHelpers.getStamp()
    
}





static saveField(ref, value) {
    ref.set(value)
}

//Copy list from one path to another with new keys...

static copyItems(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    this.fetchItemsFromFirebase(fromRef).then(fromItems => {
        fromItems.forEach(item => {
            item.meta.path = toPath
            this.saveItem(item)
        })
        console.log('copyItems reports ' + fromItems.length + ' items copied from ' + this.firebaseRefToPath(fromRef) + ' to ' + toPath + '.')
    })
}

//Copy item from one path to another (key must be included in path)

static copySingleItem(fromRef, toRef) {
    let toPath = this.firebaseRefToPath(toRef)
    let toKey = this.firebaseRefToKey(toRef)
    this.fetchItemSingle(fromRef).then(fromItem => {
        fromItem.meta.path = toPath
        fromItem.meta.key = toKey
        this.saveItem(item)
        console.log('copySingleItem copied from ' + this.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem)
    })
}


} // end class


// WEBPACK FOOTER //
// ./src/data/Data4.js